// This repository is the independent Ninyaa France project.
export const currentCountry = () => "FR";
export const instanceName = () => "Ninyaa";
